import type { ModelsNewsCard } from "../../../types";
import { NewsCard } from "../../common/news-card";

export interface NewsFeaturedSideCardsProps {
  cards: ModelsNewsCard[];
}

const NewsFeaturedSideCards = ({ cards }: NewsFeaturedSideCardsProps) =>
  cards.map((card) => (
    <NewsCard {...card} appearance="horizontal" key={`news-card-${card.id}`} />
  ));

export default NewsFeaturedSideCards;
